import { environment } from "../../environment";
import { getApiEndpoint } from "../../utils/constants/api";
import { PAGE_TEMPLATES } from "../../utils/constants/templates";
import { wfetch } from "../../utils/fetch";

export const FETCH_BRAND = "FETCH_BRAND";

export const fetchBrand = () => {
    return async (dispatch, getState) => {
        const brandId = getState().rootPageData?.brand;

        if (!brandId) return;

        const response = await wfetch(
            getApiEndpoint("BRANDS", {
                queryParams: {
                    "@jcr:uuid": brandId,
                },
            }),
        );

        if (!response || response.data.results.length === 0) return;

        dispatch({
            type: FETCH_BRAND,
            payload: response.data.results[0],
        });
    };
};
